// exp_PORTFOLIO-61587_file
import { push } from 'connected-react-router';
import { convertRegionsFromDto } from 'utils/campaign';
import { VacancyInfoRequirement } from 'utils/campaign/requirementUtils/types';
import { sortAreas, sortProfRoles } from 'utils/clickme';
import { CREATE_MENU_PAGE_ROUTE } from 'utils/constants/app';
import { BEProfRoles, hasProfRoles } from 'utils/profRoles';
import { BASE_VACANCY_OF_THE_DAY_PRESETS, VacancyOfTheDayPresetId } from 'utils/vacancyOfTheDay';

import { Requirements } from 'app/routes';

import store from 'store';
import { PROF_ROLES, RegionBE, setProfRoles, setRegions } from 'store/autoReducers';
import type { Action } from 'store/createReducer';
import { selectWizardCampaignOptions } from 'store/models/campaignCreationWizard';
import { selectMainMenuVacancyId } from 'store/models/mainMenu';
import { setVacancyOfTheDayForm } from 'store/models/vacancyOfTheDay';

export const VacancyOfTheDayPageRequirements: Requirements<{
    regions: RegionBE[];
    vacancyInfo: VacancyInfoRequirement;
    [PROF_ROLES]: BEProfRoles;
}> = {
    methods: ({ state }) => {
        const vacancyId = selectMainMenuVacancyId(state);

        return {
            regions: { url: '/api/v1/catalog/areas' },
            [PROF_ROLES]: { url: '/api/v1/catalog/professionalCatalog' },
            ...(vacancyId && {
                vacancyInfo: { url: `/api/v1/vacancy/campaign_info_from_vacancy?vacancyId=${vacancyId}` },
            }),
        };
    },
    isDataReady: ({ result }) => hasProfRoles(result),
    resolve: ({ state, result: { regions, vacancyInfo, ...professions } }) => {
        const vacancyId = selectMainMenuVacancyId(state);

        if (!vacancyId) {
            store.dispatch(push(CREATE_MENU_PAGE_ROUTE));
            return [];
        }

        const presets = selectWizardCampaignOptions(state)?.vacancyOfTheDayPresets ?? BASE_VACANCY_OF_THE_DAY_PRESETS;
        const medium = presets.MEDIUM;
        const profRoles = professions[PROF_ROLES];

        const actions: Action[] = [
            setRegions(sortAreas(convertRegionsFromDto(regions))),
            ...(profRoles ? [setProfRoles(sortProfRoles(profRoles.professionalCategories))] : []),
            setVacancyOfTheDayForm({
                vacancy: {
                    vacancyId,
                    vacancyName: vacancyInfo.title,
                    vacancyUrl: vacancyInfo.url,
                    areaId: vacancyInfo.areaId,
                },
                areas: vacancyInfo.areaId ? [vacancyInfo.areaId] : [],
                roles: vacancyInfo.profRoleIds,
                presets,
                preset: VacancyOfTheDayPresetId.Medium,
                clicks: medium.clicks,
                budget: medium.budget,
            }),
        ];

        return actions;
    },
};
